import { useTranslation } from 'react-i18next';

/**
 * Custom hook that wraps useTranslation and ensures all translations return strings
 * This fixes React Error #31 in production builds where t() might return objects
 */
export const useSafeTranslation = () => {
  const { t, i18n } = useTranslation();

  // Wrap the t function to always return a string
  const safeT = (key, fallbackOrOptions) => {
    try {
      const result = t(key, fallbackOrOptions);
      
      // If result is not a string, return the fallback or key
      if (typeof result !== 'string') {
        console.warn(`Translation for "${key}" returned non-string:`, typeof result);
        
        // If fallbackOrOptions is a string, use it as fallback
        if (typeof fallbackOrOptions === 'string') {
          return fallbackOrOptions;
        }
        
        // Extract the last part of the key as fallback
        return key.split('.').pop() || key;
      }
      
      return result;
    } catch (error) {
      console.error(`Translation error for key "${key}":`, error);
      return typeof fallbackOrOptions === 'string' ? fallbackOrOptions : key;
    }
  };

  return { t: safeT, i18n, originalT: t };
};

export default useSafeTranslation;
